var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconRegistrationviablood30 = function SvgAIconRegistrationviablood30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3 18.3592C23.3 23.1314 19.7176 27 14.9 27C10.0824 27 6.5 22.5766 6.5 18.3592C6.5 14 11.5555 6.64348 13.8506 3.50974C14.0853 3.18952 14.4605 3 14.8599 3C15.2594 3 15.6346 3.18952 15.8692 3.50974C18.1657 6.64348 23.3 13.587 23.3 18.3592Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19C19.5 20.7778 17.7222 23 15.5 23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export { SvgAIconRegistrationviablood30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjMuMyAxOC4zNTkyQzIzLjMgMjMuMTMxNCAxOS43MTc2IDI3IDE0LjkgMjdDMTAuMDgyNCAyNyA2LjUgMjIuNTc2NiA2LjUgMTguMzU5MkM2LjUgMTQgMTEuNTU1NSA2LjY0MzQ4IDEzLjg1MDYgMy41MDk3NEMxNC4wODUzIDMuMTg5NTIgMTQuNDYwNSAzIDE0Ljg1OTkgM0MxNS4yNTk0IDMgMTUuNjM0NiAzLjE4OTUyIDE1Ljg2OTIgMy41MDk3NEMxOC4xNjU3IDYuNjQzNDggMjMuMyAxMy41ODcgMjMuMyAxOC4zNTkyWiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTE5LjUgMTlDMTkuNSAyMC43Nzc4IDE3LjcyMjIgMjMgMTUuNSAyMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPC9zdmc+";